import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';

function FirstTimeUserModal({ pendingApproval = false }) {

    const [ showVerNoticeModal, setShowVerNoticeModal ] = useState(true);

    const handleClose = () => {
        setShowVerNoticeModal(false)
    }

    return (
        <>
            <Modal
                className='user-signup-modal first-signup-modal'
                show={showVerNoticeModal}
                onHide={handleClose}
                size="lg"
                backdrop="static"
                keyboard={false}
                centered >

                <Modal.Body>
                    {pendingApproval ? (
                        <>
                            <h3>Your request has been submitted</h3>
                            <p>Your account will be reviewed and our team will get back to you within 3 business days with a confirmation email.</p>
                            <p>Need additional help? Contact <a href="mailto:support@linksbridge.com">support@linksbridge.com</a></p>
                        </>
                    ) : (
                        <>
                            <h3>Something went wrong</h3>
                            <p>We may be experiencing some downtime and maintenance. If you still run into issues, please reach out to <a href="mailto:support@linksbridge.com">support@linksbridge.com</a>.</p>
                        </>
                    )}
                </Modal.Body>
            </Modal>
        </>
    )
}

export default FirstTimeUserModal;